import useContentPermissions from "@src/components/libraryItemDetailPages/hooks/useContentPermissions";
import { ContentPermissionsFragment } from "@src/components/libraryItemDetailPages/hooks/useContentPermissions.generated";
import { useAtomValue } from "jotai";
import { selectAtom } from "jotai/utils";
import { isEqual } from "lodash";
import { useMemo } from "react";
import { courseVersionCourseIdAtom } from "../atoms";

const useCourseBuilderContentPermissions = ():
  | ContentPermissionsFragment
  | undefined => {
  const input = useAtomValue(
    useMemo(
      () =>
        selectAtom(
          courseVersionCourseIdAtom,
          (courseId) => ({ courseId }),
          isEqual,
        ),
      [],
    ),
  );
  return useContentPermissions(input);
};

export default useCourseBuilderContentPermissions;
